export default __webpack_public_path__ + "static/media/cashApp.e2d27343.JPEG";